import angular from 'angular';
import otherDirectCostsReviewDetailsComponent from './other-direct-costs-review-details.component';

let otherDirectCostsReviewDetailsModule = angular.module('otherDirectCostsReviewDetails', [])
  .component('otherDirectCostsReviewDetails', otherDirectCostsReviewDetailsComponent);

export default otherDirectCostsReviewDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/other-direct-costs-review-details/other-direct-costs-review-details.js